import React from 'react'

export const RRHHMainScreen = () => {
  return (
    <div className="main-container"></div>
  )
}
